import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=a0761eaa&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0761eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0761eaa')) {
      api.createRecord('a0761eaa', component.options)
    } else {
      api.reload('a0761eaa', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=a0761eaa&scoped=true&", function () {
      api.rerender('a0761eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports